// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"186930d5","952":"e74baf87"}[chunkId] + ".chunk.css";
};